import { AfterViewInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';

@Component({
  selector: 'app-team-trainings',
  templateUrl: './team-trainings.component.html',
  styleUrls: ['./team-trainings.component.scss']
})
export class TeamTrainingsComponent implements AfterViewInit {
  color: '#005C8A';
  value = 85;

  @Input() value1: any;
  @Input() teamMembers: any;
  chart: any;
  isProcessing: boolean = false;
  initialCount = 0;
  pageCount = 2;
  isPrevious = false;
  isNext = false;
  constructor(private readonly appService: AppService, private readonly router: Router, private readonly message: messageService) {

  }

  ngAfterViewInit(): void {
    for (const [index, member] of this.teamMembers.entries()) {
      const rawBadge: string = member?.badgeName ?? '';
      const sanitizedBadge = rawBadge.replaceAll('-', '').replaceAll(/\s/g, '');
      if (sanitizedBadge.length > 0) {
        member.newBadge = sanitizedBadge[0].toUpperCase() + sanitizedBadge.slice(1).toLowerCase();
      } else {
        member.newBadge = '';
      }
      this.getTrainings(member, index);
    }
    this.initialCount = 0;
    this.pageCount = 2;
    this.isPrevious = false;
    if (this.pageCount < this.teamMembers.length) {
      this.isNext = true;
    } else if (this.pageCount >= this.teamMembers.length) {
      this.isNext = false;
    }
  }


  trainingCount = 0;

getTrainings(
  user: {
    trainingCountList: any[];
    trainingsList: any[];
    totalList: number[];
    colorList: string[];
    statusList: string[];
    trainingCount: number;
  },
  chartIndex: number 
): void {
  this.trainingCount = 0;

  user.trainingCountList = [
    { levelStatus: "Completed", trainingCount: 0, color: "#92c278", percentage: 0 },
    { levelStatus: "In Progress", trainingCount: 0, color: "#ffd685", percentage: 0 },
    { levelStatus: "Yet to Start", trainingCount: 0, color: "#f5b297", percentage: 0 }
  ];

  const data = user.trainingsList ?? [];
  user.totalList = [];
  user.colorList = [];
  user.statusList = [];

  let k = 2;

  for (const item of data) {
    if (item.levelStatus === "Pending") {
      item.color = "#f5b297";
      item.levelStatus = "Yet to Start";
      user.trainingCountList[2] = item;
    } else if (item.levelStatus === "In Progress") {
      item.color = "#ffd685";
      user.trainingCountList[1] = item;
    } else if (item.levelStatus === "Completed") {
      item.color = "#92c278";
      user.trainingCountList[0] = item;
    } else {

      k = k + 1;
      user.trainingCountList[k] = item;

      if (item.levelStatus === "Pending(Next Level)" && item.trainingCount >= 1) {
        item.color = "yellow";
        item.levelStatus = "Next Levels";
      } else if (item.levelStatus === "Failed" && item.trainingCount >= 1) {
        item.color = "red";
      } else if (item.levelStatus === "Locked" && item.trainingCount >= 1) {
        item.color = "#f2f2f2";
      } else if (item.levelStatus === "Locked Overdue" && item.trainingCount >= 1) {
        item.color = "#b5bab6";
      } else if (item.levelStatus === "Locked Overdue(RM Approved)" && item.trainingCount >= 1) {
        item.color = "#fa9696";
      } else {
        item.color = "#f2f2f2";
      }
    }

    user.totalList.push(item.trainingCount);
    user.colorList.push(item.color ?? "#f2f2f2");
    
    item.percentage = ((item.trainingCount / user.trainingCount) * 100).toFixed(0);
  }

  this.chart = null;
  if (data.length > 0) {
    this.createChart(user.totalList, user.statusList, user.colorList, chartIndex);
  } else {
    this.createChart(['100'], [''], ['gray'], chartIndex);
  }
}

  createChart(totalList: any, statusList: any, colorList: any, i: any) {
    let id = "MyChart" + i;
    this.chart = new Chart(id, {
      type: 'doughnut',

      data: {
        datasets: [{

          data: totalList,
          backgroundColor: colorList,
          hoverOffset: 4,

        }],
      },
      options: {
        responsive: true,
        cutout: '80%',
        plugins: {
          tooltip: {
            enabled: false
          },
        },
        elements: {

        }
      }
    });
  }


addBadges(badgeName: string, userCount?: number): Record<string, string> {
  
  const imagePath = `../../../assets/img/${badgeName}.png`;

  return {
    "background": `transparent url(${imagePath}) no-repeat center 35px`,
    "margin": "0px auto",
    "height": "140px !important",
    "width": "90% !important",
    "margin-left": "-4%"
  };
}


  applyStyle(value: any) {
    return {
      "background-color": value
    };
  }

  backToPreviousPage() {
    this.message.breadcrumbData.thirdLevel = "";
    history.back();
  }

  previousClick() {
    this.pageCount = this.pageCount - 2;
    this.initialCount = this.initialCount - 2;

    if (this.pageCount < this.teamMembers.length) {
      this.isNext = true;
    } else if (this.pageCount >= this.teamMembers.length) {
      this.isNext = false;
    }

    if (this.initialCount) {
      this.isPrevious = true;
    } else {
      this.isPrevious = false;
    }
  }

  nextClick() {
    this.pageCount = this.pageCount + 2;
    this.initialCount = this.initialCount + 2;
    if (this.pageCount < this.teamMembers.length) {
      this.isNext = true;
    } else if (this.pageCount >= this.teamMembers.length) {
      this.isNext = false;
    }

    if (this.initialCount) {
      this.isPrevious = true;
    } else {
      this.isPrevious = false;
    }
  }

}
